
class Size {
    
    constructor(width, height) {
        this.width = width;
        this.height = height;
    }
    
    setWidth(width) {
        this.width = width;
        return this;
    }

    setHeight(height) {
        this.height = height;
        return this;
    }

    getWidth() {
        return this.width;
    }

    getHeight() {
        return this.height;
    }
    
}

export default Size
